<template>
  <div class="classroom-container">
    <div :style="{fontSize: IDE.setting.fontSize + 'px'}"
         class="web-classroom">
      <div class="message-panel">
        <message-window
            v-if="IClassroom.group">
        </message-window>
      </div>
      <div class="classmates-panel">
        <classmates></classmates>
      </div>
      <div class="bottom-panel">
        <bottom-panel></bottom-panel>
      </div>
    </div>
  </div>
</template>

<script>
import MessageWindow from '@/components/classroom/message_window/MessageWindow'
import IClassroom from '@/components/classroom/lib/IClassroom'
import '@/components/classroom/style/classroom.styl'
import Classmates from '@/components/classroom/web/classmates/Classmates'
import BottomPanel from '@/components/classroom/web/BottomPanel'

const IDE = window['IDE']

export default {
  components: { MessageWindow, Classmates, BottomPanel },
  data () {
    return {
      IDE,
      IClassroom
    }
  }
}
</script>

<style lang="stylus" scoped>
@keyframes classroom-enter {
  0% {
    transform: translateY(2rem)
  }

  100% {
    transform: translateY(0rem)
  }
}

.classroom-container {
  overflow hidden
}

.web-classroom {
  position: relative;
  height: 100%;
  width 100%
  display flex
  animation: classroom-enter .5s ease-out;
}

.message-panel, .classmates-panel {
  display inline-block
  height 100%
  width calc(100% - 250px)
  overflow hidden
}


.classmates-panel {
  width 250px
  flex-shrink 0
  background white
  overflow visible
  text-align center
}

.bottom-panel {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  padding: 0 9px 0 5px;
  z-index: $zIndexFloat;
  display: flex;
  background: #fff;
  border-radius: 5px;
  align-items: center;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, .2);
  user-select none
}
</style>
